import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

export const StoreRouter = {
    BrowserRouter,
    Redirect,
    Route,
    Switch
}